import axios from 'axios';
import RedisInfo from './RedisInfo';
 
const apiUrl = process.env.REACT_APP_API_URL;
const homePageDetails = async (lang) => {
    try {
      const token =sessionStorage.getItem('token');
     const responseRedisData = await RedisInfo.redisDetails();
                
                 const parentGroup = responseRedisData.ParentGroup
                 console.log("parentGroup in homePageDetails:", parentGroup);
                 const dealerMapCode=responseRedisData.DealerMapCode
                  console.log("dealerMapCode in homePageDetails:", dealerMapCode);
                 const locCode=responseRedisData.LocCode
                  console.log("locCode in homePageDetails:", locCode);
                
                 const API_URL = `${apiUrl}/api/v1/serviceDetails/getActiveServiceForDealer/${parentGroup}/${dealerMapCode}/${locCode}?lang=${lang}`;
                 const response = await axios.get(API_URL, {
                  headers: {
                    Authorization: `Bearer ${token}`
                  }
                });
     
      return response.data;
    } catch (error) {
      console.error("Error fetching service details:", error);
      throw error;
    }
  };
 // added//
 const homePageOtherServiceDetails = async (lang) => {
  try {
    const token =sessionStorage.getItem('token');
   const responseRedisData = await RedisInfo.redisDetails();
              
               const parentGroup = responseRedisData.ParentGroup
                console.log("parentGroup in homePageOtherServiceDetails:", parentGroup);
               const dealerMapCode=responseRedisData.DealerMapCode
                console.log("dealerMapCode in homePageOtherServiceDetails:", dealerMapCode);
               const locCode=responseRedisData.LocCode
                console.log("locCode in homePageOtherServiceDetails:", locCode);
              
               const API_URL = `${apiUrl}/api/v1/serviceDetails/getOtherServiceForDealer/${parentGroup}/${dealerMapCode}/${locCode}?lang=${lang}`;
               const response = await axios.get(API_URL, {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              });
   
    return response.data;
  } catch (error) {
    console.error("Error fetching service details:", error);
    throw error;
  }
};
 
 //added//
 const HomePageService = {
  homePageDetails,
  homePageOtherServiceDetails
};

export default HomePageService;
  //export default { homePageDetails };